/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Role_Not_AssignableInputs */

const en_adm_err_role_not_assignable = /** @type {(inputs: Adm_Err_Role_Not_AssignableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The owner role cannot be assigned. Use the owner switch on the user instead.`)
};

const de_adm_err_role_not_assignable = /** @type {(inputs: Adm_Err_Role_Not_AssignableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Eigentümer-Rolle kann nicht zugewiesen werden. Nutze stattdessen den Eigentümer-Schalter beim Benutzer.`)
};

/**
* | output |
* | --- |
* | "The owner role cannot be assigned. Use the owner switch on the user instead." |
*
* @param {Adm_Err_Role_Not_AssignableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_role_not_assignable = /** @type {((inputs?: Adm_Err_Role_Not_AssignableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Role_Not_AssignableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_role_not_assignable(inputs)
	return en_adm_err_role_not_assignable(inputs)
});